// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2kqqA","content":"ManualTimeModal_content__203s2"};